module.exports = __webpack_public_path__ + "static/media/Texture.8a46ad19.jpg";